/** Mirrors crm ProposalStatus. */
export const PROPOSAL_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'rejected', label: 'Rejected' },
] as const;

export type ProposalStatus = (typeof PROPOSAL_STATUSES)[number]['value'];

export const statusLabel = (s: string): string =>
  PROPOSAL_STATUSES.find((x) => x.value === s)?.label ?? s;

export function statusVariant(s: string): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'accepted') return 'default';
  if (s === 'rejected') return 'destructive';
  if (s === 'sent') return 'secondary';
  return 'outline'; // draft
}
